export interface Props {
	title: string;
	content: string;
}

export enum GameTutorialElements {
	INTRO_MODAL = "intro",
	FILE_BUTTON = "fileButton",
	FILE_BROWSER_WINDOW = "fileBrowserWindow",
	FILE_TILE = "fileTile",
	EMAIL_BUTTON = "emailButton",
	EMAIL_BROWSER_WINDOW = "emailBrowserWindow",
	CHAT_BUTTON = "chatButton",
	CHAT_BROWSER_WINDOW = "chatBrowserWindow",
	NOTE_BUTTON = "noteButton",
	NOTE_BORWSER_WINDOW = "noteBrowserWindow",
	BROWSER_BUTTON = "browserButton",
	LOGOUT_BUTTON = "logoutButton",
	HELP_BUTTON = "helpButton",
}
